export const GameColor: { [key: string]: string } = {
    'Persona 3 Reload': '#00c2f3',
    'Persona 4 Golden': '#f1e900',
    'Persona 4 Revival': '#f1e900',
    'Persona 5 Royal': '#d4000b',
    'Persona 5: The Phantom X': '#d4000b',
    'Metaphor: ReFantazio': '#b5651d',
};

export const PlatformColor: { [key: string]: string } = {
    'Nintendo Switch': '#FF0000',
    'Steam': '#248ac5',
    'Microsoft Store': '#107C10',
    'Google Play': '#FFCC00',
};

export const DownloadTypes: { [key: string]: string } = {
    'reloaded-ii': 'Reloaded II',
    'pak-patch': 'PAK Patch',
};

export const getPlatformColor = (platform: string): string => {
    return PlatformColor[platform] || '#6c757d'; // Default to gray if no match
};

export const getGameColor = (game: string): string => {
    return GameColor[game] || '#000';
};

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';